import {
  getPageListData,
  deletePageData,
  createPageData,
  editPageData,
  getAllTypes,
} from "@/service/main/system/system";
import { ISystemState } from "./type";
import { createStore, Store, useStore as useVuexStore } from "vuex";
import { accountLoginRequest, getUserInfoRequest } from "@/service/login/login";
import localCache from "@/utils/cache";

const store = createStore<ISystemState>({
  state() {
    return {
      goodsList: [],
      goodsCount: 0,
      selectionList: [],
      types: [],
      clothList: [],
      clothCount: 0,
      // selectionList: [],
      // types: [],
      token: "",
      userInfo: {
        username: "",
        password: "",
      },
      packingList: [],   // tableData
      packingBoxNo: 0,  // 输入的箱号
      packager: '',
      nickname: '',
    };
  },
  mutations: {
    selectionChange(state, value: any[]) {
      state.selectionList = value;
    },
    changeGoodsList(state, list: any[]) {
      state.goodsList = list;
    },
    changeGoodsCount(state, count: number) {
      state.goodsCount = count;
    },
    getAllTypes(state, list: any[]) {
      state.types = list;
    },
    changeClothList(state, list: any[]) {
      state.clothList = list;
    },
    changeClothCount(state, count: number) {
      state.clothCount = count;
    },
    changeToken(state, token: string) {
      state.token = token;
    },
    changeUserInfo(state, userInfo: any) {
      state.userInfo = userInfo;
    },
    /** ======= 新增：修改装箱列表 ======= */
    changePackingList(state, list) {
      state.packingList = list;
    },

    /** ======= 新增：修改箱号 ======= */
    changePackingBoxNo(state, boxNo) {
      state.packingBoxNo = boxNo;
    },
    SET_PACKING_LIST(state, list) {
      state.packingList = list;
    },
    SET_PACKAGER(state, packager) {
      state.packager = packager;
    },
    SET_NICKNAME(state, nickname) {
      state.nickname = nickname;
    }
  },
  getters: {
    pageListData(state) {
      // 返回一个函数，参数是pageName
      return (pageName: string) => {
        return (state as any)[`${pageName}List`];
      };
    },
    pageListCount(state) {
      return (pageName: string) => {
        return (state as any)[`${pageName}Count`];
      };
    },
  },
  actions: {
    setPackager({ commit }, packager) {
      commit('SET_PACKAGER', packager);
    },
    setNickname({ commit }, nickname) {
      commit('SET_NICKNAME', nickname);
    },
    /** ======= 新增：设置装箱列表 ======= */
    setPackingList({ commit }, list) {
      commit("changePackingList", list);
    },

    /** ======= 新增：设置箱号 ======= */
    setPackingBoxNo({ commit }, boxNo) {
      commit("changePackingBoxNo", boxNo);
    },
    selectionChange({ commit }, payload: any) {
      commit(`selectionChange`, payload);
    },

    async getAllTypes({ commit }) {
      const pageResult = await getAllTypes("/sku/types");
      // console.log(pageResult);
      const types = pageResult?.body || []; // 如果 body 为空 → 返回空数组

      commit("getAllTypes", types);
      // commit(`getAllTypes`, pageResult.body);
    },

    async getPageListAction({ commit }, payload: any) {
      // 2.对页面发送请求
      const pageResult = await getPageListData(
        payload.pageUrl,
        payload.queryInfo
      );
      // console.log("获取数据", pageResult);

      // 3.将数据存储到state中
      // const { body, count } = pageResult;
      const body = Array.isArray(pageResult?.body) ? pageResult.body : [];
      const count =
        typeof pageResult?.count === "number" ? pageResult.count : 0;

      // commit(`changeGoodsList`, body);
      // commit(`changeGoodsCount`, count);
      const pageName = payload.pageName;
      const changePageName =
        pageName.slice(0, 1).toUpperCase() + pageName.slice(1);
      commit(`change${changePageName}List`, body);
      commit(`change${changePageName}Count`, count);
    },

    async deletePageDataAction({ dispatch }, payload: any) {
      // 1.获取pageName和id
      // pageName -> /users
      // id -> /users/id
      const { pageName, id } = payload;
      const pageUrl = `/${pageName}/${id}`;

      // 2.调用删除网络请求
      await deletePageData(pageUrl);

      // 3.重新请求最新的数据
      dispatch("getPageListAction", {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10,
        },
      });
    },

    async createPageDataAction({ dispatch }, payload: any) {
      // 1.创建数据的请求
      const { pageName, newData } = payload;
      const pageUrl = `/${pageName}`;
      await createPageData(pageUrl, newData);

      // 2.请求最新的数据
      dispatch("getPageListAction", {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10,
        },
      });
    },

    async editPageDataAction({ dispatch }, payload: any) {
      console.log("确认2", payload);

      // 1.编辑数据的请求
      const { pageName, editData, id } = payload;
      console.log(editData);
      const pageUrl = `/${pageName}/${id}`;
      await editPageData(pageUrl, editData);

      // 2.请求最新的数据
      dispatch("getPageListAction", {
        pageName,
        queryInfo: {
          offset: 0,
          size: 10,
        },
      });
    },

    async accountLoginAction({ commit }, payload: any) {
      // console.log("执行 accountLoginAction, 参数:", payload)

      // 1. 发送账号密码登录请求
      const loginResult = await accountLoginRequest(payload);
      // console.log("执行 accountLoginAction, 返回:", loginResult);
      if (!loginResult || !loginResult.body) {
        return;
      }
      const token = loginResult.body;
      commit("changeToken", token);

      // 本地缓存
      localCache.setCache("token", token);

      // 2. 再根据 token 获取用户信息
      const userInfoResult = await getUserInfoRequest();
      // console.log("执行 getUserInfoRequest, 返回:", userInfoResult)
      commit("changeUserInfo", userInfoResult.body);

      localCache.setCache("userInfo", userInfoResult.body);
      // localCache.setCache("extensionId", userInfoResult.body.extensionId);
      localCache.setCache("owner", userInfoResult.body.owner);
      localCache.setCache("perms", userInfoResult.body.perms);
    },

    // 页面刷新时加载本地数据（可选）
    loadLocalLogin({ commit }) {
      const token = localCache.getCache("token");
      const userInfo = localCache.getCache("userInfo");
      if (token) commit("changeToken", token);
      if (userInfo) commit("changeUserInfo", userInfo);
    },
  },
});

export function initData() {
  store.dispatch("getAllTypes");
}

export default store;
